import { useState } from "react"

import { DefaultPopover, Button, ColorPickerInputGroup } from "twyne-new.ui"

const AddPopover = ({ editing, onSubmit, trigger, color: colorProps }) => {
  const [open, setOpen] = useState(false)
  const [color, setColor] = useState(colorProps)

  const handleSubmit = () => {
    onSubmit(color)
    setOpen(false)
    setColor()
  }

  const handleClose = () => {
    setOpen(false)
    setColor()
  }

  return <>
    <DefaultPopover
      trigger={trigger}
      triggerProps={{ asChild: true }}
      contentProps={{ side: 'bottom', align: 'center', onInteractOutside: handleClose }}
      wrapperProps={{ open: open, onOpenChange: setOpen }}
    >
      <div className='flex flex-col gap-2'>
        <ColorPickerInputGroup
          value={color}
          onChange={setColor}
          components={['picker']}
          pickerClassName='!w-full'
        />
        <div className='flex gap-2'>
          <Button disabled={!color} block size='sm' color='accent' onClick={handleSubmit}>
            {editing ? 'Update' : 'Add'}
          </Button>
          <Button block variant='outline' size='sm' onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </DefaultPopover>
  </>
}

export default AddPopover
